import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import WarningIcon from "@material-ui/icons/Warning";
import InfoIcon from "@material-ui/icons/Info";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: "16px",
      padding: "24px",
      maxWidth: "400px",
      width: "100%",
      backgroundColor: "#1F2937",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      boxShadow:
        "0px 4px 6px -1px rgba(0, 0, 0, 0.2), 0px 2px 4px -1px rgba(0, 0, 0, 0.1)",
    },
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "16px",
    "& .MuiSvgIcon-root": {
      fontSize: "48px",
      color: "#EF4444",
    },
  },
  title: {
    color: "#EF4444",
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "8px",
    textAlign: "center",
  },
  content: {
    color: "rgba(255, 255, 255, 0.9)",
    fontSize: "15px",
    lineHeight: "1.5",
    marginBottom: "24px",
    textAlign: "center",
  },
  actions: {
    padding: "0",
    gap: "12px",
    justifyContent: "center",
    "& .MuiButton-root": {
      minWidth: "120px",
      height: "40px",
      borderRadius: "8px",
      textTransform: "none",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  deleteButton: {
    backgroundColor: "#EF4444",
    color: "white",
    "&:hover": {
      backgroundColor: "#DC2626",
    },
  },
  cancelButton: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
    },
  },
}));

const DialogWarning = ({
  primaryText,
  secondaryText,
  primaryAction,
  closeAction,
  idItem,
  open,
  primaryButtonText,
  secondaryButtonText,
  type = "danger",
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={closeAction}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.dialog}
    >
      <div className={classes.iconContainer}>
        {type === "danger" ? (
          <WarningIcon style={{ color: "#EF4444" }} />
        ) : (
          <InfoIcon style={{ color: "#22C55E" }} />
        )}
      </div>
      <DialogTitle
        id="alert-dialog-title"
        className={classes.title}
        style={{ color: type === "danger" ? "#EF4444" : "#22C55E" }}
      >
        {primaryText}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className={classes.content}
        >
          {secondaryText.split("\\n").map((text, index) => (
            <React.Fragment key={index}>
              {text}
              <br />
            </React.Fragment>
          ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          className={classes.cancelButton}
          onClick={closeAction}
          autoFocus
        >
          {secondaryButtonText}
        </Button>
        <Button
          className={classes.deleteButton}
          style={{ backgroundColor: type === "danger" ? "#EF4444" : "#22C55E" }}
          onClick={() => primaryAction(idItem)}
        >
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogWarning;
